class CardMediaSlider extends HTMLElement {
  connectedCallback() {
    this.extras = [...this.querySelectorAll('.card-slider__extra')];

    const prevZone = this.querySelector('.card-slider__zone--prev');
    const nextZone = this.querySelector('.card-slider__zone--next');

    if (this.extras.length === 0) {
      if (prevZone) prevZone.hidden = true;
      if (nextZone) nextZone.hidden = true;
      return;
    }

    this.extraIndex = -1;

    nextZone?.addEventListener('click', () => this.goExtra(this.extraIndex + 1));
    prevZone?.addEventListener('click', () => this.goExtra(this.extraIndex - 1));

    if (window.matchMedia('(pointer: fine)').matches) {
      this.addEventListener('mouseleave', () => this.goExtra(-1));
    }

    // Mobile swipe — passive touch events don't block page scroll
    let startX, startY, didSwipe = false;

    this.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      didSwipe = false;
    }, { passive: true });

    this.addEventListener('touchend', e => {
      if (startX == null) return;
      const touch = e.changedTouches[0];
      const dx = startX - touch.clientX;
      const dy = Math.abs(startY - touch.clientY);
      if (Math.abs(dx) > 35 && dy < 60) {
        didSwipe = true;
        if (dx > 0) {
          this.goExtra(this.extraIndex + 1);
        } else {
          this.goExtra(this.extraIndex - 1);
        }
      }
      startX = null;
    }, { passive: true });

    // Prevent navigation on the synthetic click that fires after a swipe
    this.addEventListener('click', e => {
      if (didSwipe) {
        e.preventDefault();
        e.stopPropagation();
        didSwipe = false;
      }
    });

    this.updateZones();
  }

  goExtra(n) {
    this.extraIndex = Math.max(-1, Math.min(n, this.extras.length - 1));

    this.extras.forEach((el, i) => {
      el.classList.toggle('is-active', i === this.extraIndex);
    });

    this.classList.toggle('slider-has-extra', this.extraIndex >= 0);
    this.updateZones();
  }

  updateZones() {
    const prevZone = this.querySelector('.card-slider__zone--prev');
    const nextZone = this.querySelector('.card-slider__zone--next');

    if (prevZone) prevZone.hidden = this.extraIndex < 0;
    if (nextZone) nextZone.hidden = this.extraIndex >= this.extras.length - 1;
  }
}

customElements.define('card-media-slider', CardMediaSlider);
